export const getLastWordsContext = (messages, maxWords = 1000) => {
  const allText = messages
    .map(m => `${m.sender}: ${m.text}`)
    .join("\n");

  const words = allText.split(/\s+/);

  const trimmedWords = words.slice(-maxWords);

  return trimmedWords.join(" ");
};